import Loadable from "components/Loadable";
import React from "react";
import CommonTab from "components/common-component/Tab";


const Supplier = Loadable(
  React.lazy(() => import("pages/Supplier/Supplier"))
);
const Brand = Loadable(React.lazy(() => import("pages/Brand/Brand")));
const Model = Loadable(
  React.lazy(() => import("pages/Assets_model/Model"))
);
const Item = Loadable(
  React.lazy(() => import("pages/Item/Item"))
);
const Asset = Loadable(
  React.lazy(() => import("./Assets"))
);
const Parent = Loadable(
  React.lazy(() => import("pages/Parent/Parent.js"))
);


// component array for tab component
const page = [
  <Asset />,
  <Brand />,
  <Item />,
  <Model />,
  <Supplier />,
  <Parent/>
];

export default function AssetTabs() {
  // header array for tab component
const header = [
  "Asset",
  "Brand",
  "Item",
  "Model",
  "Supplier",
  "Parent",
];
  return <CommonTab header={header} page={page} id="Asset" />;
}
